"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Const_1 = require("../utils/Const");
/**
 * 通知設定時の処理を記述する
 */
var NoticeSettingService = /** @class */ (function () {
    function NoticeSettingService() {
    }
    // 画面用 ----------------------------------------
    /**
     *
     * @param noticeRule 1:Webhook 2:定期
     * @param timing 1:月次 2:週次 3:日時
     * @param week
     * @param day
     * @param hour
     * @param enabled 通知ON
     */
    NoticeSettingService.isInvalid = function (noticeRule, timing, week, day, hour, enabled) {
        if (enabled === void 0) { enabled = true; }
        // console.log("noticeRule;" + noticeRule)
        // console.log("timing;" + timing)
        // console.log("week;" + week)
        // console.log("day;" + day)
        // console.log("hour;" + hour)
        if (!enabled) {
            // 通知オフの場合時間は見ない
            return "";
        }
        if (Number(noticeRule) === 2) {
            // 入らない想定ではある
            if (!timing || Number(timing) === -1) {
                return "通知タイミングが入力されていません";
            }
            // 定期
            if (Number(hour) === -1) {
                return "時間帯が選択されていません";
            }
            // 月
            if (Number(timing) === 1 && Number(day) === -1) {
                return "日付が選択されていません";
            }
            // 週
            if (Number(timing) === 2 && Number(week) === -1) {
                return "週が選択されていません";
            }
            return "";
        }
        else {
            return "";
        }
    };
    // サーバ用 --------------------------------------
    /**
     * notice_ruleを元に値を整理する
     * @param params postされた値
     */
    NoticeSettingService.setNoticeRule = function (params) {
        params.enabled = params.enabled === "true";
        params.staffenabled = params.staffenabled === "true";
        if (params.notice_rule === 1) {
            // notice_rule:0 Webhookの場合
            params.timing = "1";
            params.day = "-1";
            params.week = "-1";
            params.hour = "-1";
        }
        else {
            // notice_rule:1 定期の場合
            // nop
        }
        return params;
    };
    /**
     * 画面表示用に変換して返す
     * 主に通知方法(slack等を横持ちするように変換)
     * 設定画面のデータ取得時に使用
     * @param src メンバ毎通知設定データ
     * @returns 設定画面用のデータ
     */
    NoticeSettingService.convertDisplayDataFromMemberNoticeEnabledModel = function (src) {
        var memberNoticeEnabledDispData = new Map();
        src.forEach(function (datum) {
            if (memberNoticeEnabledDispData.has(datum.member_id)) {
                // nop
            }
            else {
                memberNoticeEnabledDispData.set(datum.member_id, {
                    member_id: datum.member_id,
                    name: (datum.member_name),
                    kana: (datum.member_kana),
                    mailEnabled: false,
                    chatworkEnabled: false,
                    slackEnabled: false,
                    lineEnabled: false,
                    teamsEnabled: false,
                    lineworksEnabled: false,
                    mailAddress: (datum.mail_address),
                });
            }
            // 通知方法ごとに設定
            switch (datum.notice_method_id) {
                case Const_1.NOTICE_METHOD_TYPE.Mail:
                    memberNoticeEnabledDispData.get(datum.member_id).mailEnabled = datum.enabled === 1;
                    break;
                case Const_1.NOTICE_METHOD_TYPE.Chatwork:
                    memberNoticeEnabledDispData.get(datum.member_id).chatworkEnabled = datum.enabled === 1;
                    break;
                case Const_1.NOTICE_METHOD_TYPE.Slack:
                    memberNoticeEnabledDispData.get(datum.member_id).slackEnabled = datum.enabled === 1;
                    break;
                case Const_1.NOTICE_METHOD_TYPE.Line:
                    memberNoticeEnabledDispData.get(datum.member_id).lineEnabled = datum.enabled === 1;
                    break;
                case Const_1.NOTICE_METHOD_TYPE.Teams:
                    memberNoticeEnabledDispData.get(datum.member_id).teamsEnabled = datum.enabled === 1;
                    break;
                case Const_1.NOTICE_METHOD_TYPE.Lineworks:
                    memberNoticeEnabledDispData.get(datum.member_id).lineworksEnabled = datum.enabled === 1;
                    break;
                default:
                    break;
            }
        });
        return Array.from(memberNoticeEnabledDispData.values());
    };
    /**
     * 画面表示用のデータからデータ登録用のデータへと変換して返す
     * 主に通知方法(slack等を横持ちするように変換)
     * 設定画面のデータ取得時に使用
     * @param src メンバ毎通知設定データ
     * @returns 設定画面用のデータ
     */
    NoticeSettingService.convertMemberNoticeEnabledModelFromDisplayData = function (customerId, noticeType, enabledData) {
        var data = [];
        enabledData.forEach(function (datum) {
            // メール
            data.push({
                notice_id: noticeType,
                notice_method_id: Const_1.NOTICE_METHOD_TYPE.Mail,
                customer_id: customerId,
                member_id: datum.member_id,
                enabled: datum.mailEnabled ? 1 : 0,
            });
            // チャットワーク
            data.push({
                notice_id: noticeType,
                notice_method_id: Const_1.NOTICE_METHOD_TYPE.Chatwork,
                customer_id: customerId,
                member_id: datum.member_id,
                enabled: datum.chatworkEnabled ? 1 : 0,
            });
            // Slack
            data.push({
                notice_id: noticeType,
                notice_method_id: Const_1.NOTICE_METHOD_TYPE.Slack,
                customer_id: customerId,
                member_id: datum.member_id,
                enabled: datum.slackEnabled ? 1 : 0,
            });
            // Line
            data.push({
                notice_id: noticeType,
                notice_method_id: Const_1.NOTICE_METHOD_TYPE.Line,
                customer_id: customerId,
                member_id: datum.member_id,
                enabled: datum.lineEnabled ? 1 : 0,
            });
            // Linewoks
            data.push({
                notice_id: noticeType,
                notice_method_id: Const_1.NOTICE_METHOD_TYPE.Lineworks,
                customer_id: customerId,
                member_id: datum.member_id,
                enabled: datum.lineworksEnabled ? 1 : 0,
            });
            // Teams
            data.push({
                notice_id: noticeType,
                notice_method_id: Const_1.NOTICE_METHOD_TYPE.Teams,
                customer_id: customerId,
                member_id: datum.member_id,
                enabled: datum.teamsEnabled ? 1 : 0,
            });
        });
        return data;
    };
    /**
     * 対象がサービス可能か判定
     * @param service サービス
     * @param auth 権限
     * @returns true: サービス対象
     */
    NoticeSettingService.canUseService = function (service, auth) {
        // 1:商 2:蔵 3：商蔵両方 4：総務人事
        // 複数必須判定に===が必要
        var canService1 = (service & auth) === service;
        // 負数の場合は複数機能のうちのどれかが必要な場合はビットを反転して排他的論理和を取ってAnd
        var canService2 = service < 0 ? (service ^ auth) & ~service : false;
        return canService1 || canService2;
    };
    return NoticeSettingService;
}());
exports.NoticeSettingService = NoticeSettingService;
//# sourceMappingURL=NoticeSettingService.js.map